import orders from "../../../app-module-order-container";

const Modules = {
  orders,
};
export default Modules;
